export const pascalToCamelConverter = (string) => string.charAt(0).toLowerCase() + string.slice(1);
//# sourceMappingURL=pascalToCamel.js.map